import { PaginationProps, Table } from 'antd'
import React, { useImperativeHandle, forwardRef } from 'react'
import { useAntdTable } from 'ahooks'
import type { ColumnsType, TableProps } from 'antd/es/table'

// 封装通用table组件
interface AppTableT<T> {
  rowKey: string
  api: (args: ListParamT) => Promise<ListResT<T>>
  pageIndex?: number
  pageSize?: number
  columns: ColumnsType
  params?: Record<string, any>
  tableParams?: TableProps<T>
}

interface Result {
  total: number
  list: any
}

export const paginationOptions: PaginationProps = {
  showTotal: total => `共${total}项数据`,
  showQuickJumper: true,
  showSizeChanger: true,
  pageSizeOptions: [10, 20, 50, 100],
  size: 'small',
}

function AppTable<T>(
  { columns, rowKey = 'id', api, params, pageIndex = 1, pageSize = 10, ...rest }: AppTableT<T>,
  ref: React.RefObject<any>,
) {
  const getTableData = ({ current, pageSize: pgSize }): Promise<Result> =>
    api({ ...params, pageIndex: current, pageSize: pgSize }).then(res => ({
      total: res.totalCount,
      list: res.result || (res as any)?.data,
    }))
  // const getTableData = useCallback(
  //   ({ current, pageSize: pgSize }): Promise<Result> =>
  //     api({ ...params, pageIndex: current, pageSize: pgSize }).then(res => ({
  //       total: res.totalCount,
  //       list: res.result,
  //     })),
  //   [api, params]
  // )

  const { tableProps } = useAntdTable(getTableData, {
    defaultParams: [
      {
        current: pageIndex,
        pageSize,
        // showTotal: total => `共${total}项数据`,

        // pagination:
        // ...paginationOptions,
      },
    ],
    refreshDeps: [params],
  })

  const { pagination, dataSource } = tableProps
  const newPagination = { ...pagination, ...paginationOptions }
  useImperativeHandle(ref, () => ({
    refreshTable: () => {
      // getLists({page, pageSize})
    },
    // getDataSource: () => dataSource,
    getTableInfo: () => ({
      pagination: newPagination,
      dataSource,
    }),
  }))
  return (
    <Table
      rowKey={rowKey}
      columns={columns}
      {...tableProps}
      pagination={newPagination}
      {...(rest.tableParams as any)}
    />
  )
}

export default forwardRef(AppTable)
